export type CommonVersionAttribute = {
  code: 'version';
  readonly type?: 'string';
  readonly title?: string;
  value: string | null;
  readonly defaultValue?: string | null;
  readonly displayValue?: string | null;
  readonly extra?: any; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
  readonly required?: boolean;
  override: boolean;
  readonly hasPublishControl?: boolean;
  publish: boolean;
};
